import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { SiteLinksDirectory, RelatedPages } from "@/components/SiteLinksDirectory";
import { allContentPages } from "@/lib/site-pages";

export const Footer = ({ hideSiteLinks = false }: { hideSiteLinks?: boolean } = {}) => {
  const currentYear = new Date().getFullYear();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isContentPage = allContentPages.some((p) => p.href === pathname);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsLoggedIn(!!session);
    });
    supabase.auth.getSession().then(({ data: { session } }) => setIsLoggedIn(!!session));
    return () => subscription.unsubscribe();
  }, []);

  return (
    <>
      {isContentPage && <RelatedPages currentPath={pathname} />}
      <footer className="w-full py-4 px-4 mt-8 border-t border-border/40">
        {!isLoggedIn && !hideSiteLinks && <SiteLinksDirectory />}
        <div className="container mx-auto">
          <div className="flex flex-col items-center gap-2 text-xs text-foreground text-center">
            <div className="flex flex-col items-center gap-0.5">
              <span>© {currentYear}</span>
              <span className="whitespace-nowrap">De Hussel App by:{" "}
                <a
                  href="https://ayemate.nl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-primary/80 transition-colors">
                  Ayemate.nl
                </a>
              </span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-muted-foreground">
              <a href="/algemene-voorwaarden" className="hover:text-primary transition-colors whitespace-nowrap text-[10px] sm:text-xs">
                Algemene Voorwaarden
              </a>
              {isLoggedIn ? (
                <>
                  <span className="text-[10px] sm:text-xs">•</span>
                  <a href="/privacy" className="hover:text-primary transition-colors whitespace-nowrap text-[10px] sm:text-xs">
                    Privacybeleid (app)
                  </a>
                </>
              ) : (
                <>
                  <span className="text-[10px] sm:text-xs">•</span>
                  <a href="/privacy-website" className="hover:text-primary transition-colors whitespace-nowrap text-[10px] sm:text-xs">
                    Privacybeleid (website)
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
